export const BUILDER_MAP_MODE = {
  EDIT: 'BUILDER_MAP_MODE.EDIT',
  TOGGLE: 'BUILDER_MAP_MODE.TOGGLE',
}

export const BUILDER_MAP_COLOR_INACTIVE = '#000000'
export const BUILDER_MAP_COLOR_POSTCODE = '#004360'
